/*jslint white: true, nomen: true */
/*global $, angular */
(function () {
    angular
    .module('app.common')
    .service('PinterestTrackingService', ['$http', function ($http) {

        function getHsConsent() {
            const match = document.cookie.match(/(?:^|;\s*)__hs_cookie_cat_pref=([^;]+)/);
            if (!match) return null;

            const raw = decodeURIComponent(match[1] || '');
            if (raw.includes(',') || raw.includes('_') && raw.includes(':')) {
                const pairs = raw.split(/[,_]/).map(string => string.split(':'));
                const flags = Object.fromEntries(
                    pairs.map(([key, val]) => [key, val === 'true' || val === '1' || val === 'yes'])
                );
                return {
                    analytics:  flags['1'],
                    advertising: flags['2'],
                    functional: flags['3'],
                    raw
                };
            }
            return { raw, unknown: true };
        }

        function getConsent() {
            var hsConsent = getHsConsent();
            var advertisingConsent = hsConsent && hsConsent.advertising;
            return !!advertisingConsent || false;
        }

        function fireTag(payload) {
            window.dataLayer = window.dataLayer || [];

            let tagPayload = {
                event: payload.event,
                event_id: payload.id,
                platform: payload.platform || 'pinterest'
            };

            const lenBefore = window.dataLayer.length;
            
            window.dataLayer.push(tagPayload);

            const lenAfter = window.dataLayer.length

            console.log("PTS Tag Status:", lenAfter > lenBefore);

            return lenAfter > lenBefore;
        }

        function fireCapi(payload) {
            return $http({
                method: "POST",
                url: "/api/pinterest/conversions", 
                data: $.param({
                    event: payload.name,
                    eventId: payload.id,
                    data: payload.data
                }),
                headers: {
                "Content-Type": "application/x-www-form-urlencoded"
                }
            })
            .then(function(response) {
                const statusCode = response.status;
                console.log("PTS POST Status: ", statusCode);
                return true;
            })
            .catch(function(error) {
                console.error("PTS POST Failed: ", error);
                return false;
            });
        }

        this.generateEventId = function() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(character) {
                var randomNumber = Math.random() * 16 | 0;
                var value = (character === 'x')
                    ? randomNumber
                    : (randomNumber & 0x3 | 0x8);
                return value.toString(16);
            });
        }

        this.push = function(event) {
            if (!getConsent()) {
                console.warn("PinterestTrackingService: blocked due to no consent", event);
                return false;
            }

            event.id = event.id || this.generateEventId();

            const payload = {
                event: event.name || 'pagevisit',
                data: event.data || {},
                id: event.id
            };

            const tagCheck = fireTag(payload);

            let capiCheck = true;
            if (event.name === 'lead' || event.name === 'signup') {
                try {
                    capiCheck = fireCapi(event);
                } catch (err) {
                    console.error("fireCapi failed:", err, event);
                    capiCheck = false;
                }
            }

            return !!tagCheck && !!capiCheck;
        };
    }]);
})();
